// extracted by mini-css-extract-plugin
export default {"list":"index_list_wz7MS clearfix"};